import React from 'react';
import {BreadCrumbs} from '../components/common/bread-crumbs/BreadCrumbs';
import {SEOText} from '../components/g2/seo-text/SEOText';
import {SEOTextRevised} from '../components/g2/seo-text/SEOTextRevised';
import {LinkPiles} from '../components/common/linkpiles/LinkPiles';
import {PopularDestinations} from '../components/g2/popular-destinations/PopularDestinations';
import {PropertyTypes} from '../components/g2/property-types/PropertyTypes';
import {GreatPlacesToStay} from '../components/g2/great-places-to-stay/GreatPlacesToStay';
import DateModal from '../components/common/date-modal/DateModal';
import {AsyncDestinationUrgency} from '../components/common/destination-urgency/AsyncDestinationUrgency';
import {AsyncDestinationInfographic} from '../components/common/destination-infographic/AsyncDestinationInfographic';
import {AsyncQuickSeRPFilters} from '../components/common/quick-serp-filters/AsyncQuickSeRPFilters';
import {AsyncReviews} from '../components/common/review/AsyncReviews';
import {withErrorBoundary} from '../components/common/error-boundary/ErrorBoundary';
import {MmgLinks} from '../components/common/mmg-links/MmgLinks';
import SeoLinkpile from '../components/common/seo-linkpile/SeoLinkpile';
import {BackToTopComponent} from '../components/common/back-to-top-button/BackToTopComponent';
import {AsyncTrustpilot} from '../components/common/trustpilot/AsyncTrustpilot';
import {AsyncRecentTravelerActivity} from '../components/common/recent-traveler-activity/AsyncRecentTravelerActivity';
import LazyLoad from '../components/common/lazy-image/react-lazyload';
import {LAZY_LOAD_OFFSET} from '../utils/constants';
import MvtTest from '../components/common/mvt/MvtTest/MvtTest';
import {TESTS} from '../../shared/utils/abacus';

const {DEFAULT: LAZY_LOAD_OFFSET_DEFAULT} = LAZY_LOAD_OFFSET;

export const Template = () => (
    <React.Fragment>
        <main className="app-main">
            <BreadCrumbs />
            {withErrorBoundary(<LazyLoad once offset={LAZY_LOAD_OFFSET_DEFAULT} ><AsyncRecentTravelerActivity /></LazyLoad>)}
            {withErrorBoundary(<AsyncDestinationUrgency />)}
            {withErrorBoundary(<LazyLoad once offset={LAZY_LOAD_OFFSET_DEFAULT} ><AsyncQuickSeRPFilters /></LazyLoad>)}
            <PopularDestinations />
            <PropertyTypes />
            {withErrorBoundary(<LazyLoad once offset={LAZY_LOAD_OFFSET_DEFAULT} ><AsyncTrustpilot /></LazyLoad>)}
            <GreatPlacesToStay />
            {withErrorBoundary(<LazyLoad once offset={LAZY_LOAD_OFFSET_DEFAULT} ><AsyncReviews /></LazyLoad>)}
            {withErrorBoundary(<AsyncDestinationInfographic />)}
            <SEOTextRevised />
            <SEOText />
            <LinkPiles />
            <BackToTopComponent />
            <DateModal />
        </main>
        <MvtTest test={TESTS.SEO_LINKPILE} report reportOnMount>
            <MmgLinks />
            {withErrorBoundary(<SeoLinkpile />)}
        </MvtTest>
    </React.Fragment>
);
